<template>
  <section>
     <!-- 全頁 Loading -->
    <v-overlay :value="overlayLoading" absolute>
      <v-progress-circular indeterminate size="64" color="primary" />
    </v-overlay>

    <SingleListSelector
      :modeOptions="modeOptions"
      :defaultMode="defaultMode"
      :modeLabel="modeLabel"
      :error="error"
      :searchByOptions="searchByOptions"
      :defaultSearchBy="defaultSearchBy"
      :tableHeaders="headers"
      :appliedList="appliedList"
      :selectedApplied.sync="selectedApplied"
      :appliedPagination="appliedPagination"
      :loadingApplied="loadingApplied"
      :appliedSearch="appliedSearch"
      :appliedSearchBy="appliedSearchBy"
      :itemsPerPage="itemsPerPage"

      @update:mode="mode = $event"
      @update:itemsPerPage="itemsPerPage = $event"
      @update:appliedSearch="onAppliedSearchUpdate"

      @fetch-applied-list="fetchAppliedList"

      @apply-one="applyOne"
      @apply-selected="applySelected"
      @mode-changed="onModeChange"
      @items-per-page-changed="onModeChange"
    />
  </section>
 
</template>

<script>
// import DualListSelector from '@/components/DualListSelector.vue';
import SingleListSelector from '@/components/SingleListSelector.vue';

import axios from "axios";

export default {
  components: {/*  DualListSelector, */ SingleListSelector },
  props: {
    point: Object
  },
  data() {
    return {
      defaultMode: 'tags',
      mode: '',
      defaultSearchBy: 'name',
      error: '',
      itemsPerPage: 10,
      appliedSearch: '',
      appliedSearchBy: 'name',
      appliedList: [],
      selectedApplied: [],
      selectedUnapplied: [],
      appliedPagination: { page: 1, total: 0 },
      loadingApplied: false,
    };
  },
  computed: {
    overlayLoading(){
      return this.loadingApplied;
    },
    modeOptions() {
      return [
        { value: 'tags', text: this.$t('tag'), key:'id' },
        { value: 'merchants', text: this.$t('tags.store'), key:'merchant_id' },
      ]
    },
    modeLabel() {
      return this.modeOptions.find(opt => opt.value === this.mode)?.text || '';
    },
    headers() {
      const options = this.mode === 'tags' ? 
      [
        { text: `${this.modeLabel}${this.$t("tags.name")}`, value: 'name', sortable:false },
        { text: this.$t("tags.actions"), value: 'actions', sortable:false }
      ] :
      [
        { text: `${this.modeLabel}${this.$t("tags.name")}`, value: 'name', sortable:false },
        { text: `${this.modeLabel}ID`, value: 'id', sortable:false },
        { text: this.$t("tags.actions"), value: 'actions', sortable:false }
      ];
      return options
    },
    searchByOptions() {
      const options = this.mode === 'tags' ? 
      [
        { text: this.$t('name'), value: 'name' },
      ] :
      [
        { text: this.$t('views.merchants.id'), value: 'merchant_id' },
        { text: this.$t('views.merchants.name'), value: 'name' },
        { text: this.$t('views.merchants.phone'), value: 'phone' },
        { text: this.$t('views.merchants.email'), value: 'email' },
        { text: this.$t('views.merchants.address'), value: 'address' }
      ];
      return options
    },
    appliedSearchString() {
      if (this.appliedSearch)
        return `search=${
          this.appliedSearchBy
        }:${encodeURIComponent(this.appliedSearch)}`;
      else "";
    },
  },
  methods: {
    normalizeData(items) {
      // 尋找對應的 key (merchantId 或 groupId)
      const modeOption = this.modeOptions.find(option => option.value === this.mode);
      
      const idKey = modeOption?.key || 'id'; // 獲取對應的 id 鍵，例如 'merchantId' 或 'groupId'

      return items.map(item => ({
        name: item.name,
        id: item[idKey]
      }));
    },
    onModeChange() {
      this.appliedPagination.page = 1;
      this.appliedSearch = '';
      this.appliedSearchBy = this.defaultSearchBy;
      this.fetchAppliedList(1);
    },
    async fetchAppliedList(page = 1) {
      this.loadingApplied = true;
      try {
        const res = await this.fetchData({
          mode: this.mode,
          // search: this.appliedSearchBy ? `${this.appliedSearchBy}:${this.appliedSearch}` : this.appliedSearch,
          page,
          limit: this.itemsPerPage,
          applied: true
        });
        this.appliedList = this.normalizeData(res.items);
        this.appliedPagination.total = res.total;
        this.appliedPagination.page = page;
        this.loadingApplied = false;
      } catch (e) {
        console.log('failed to fetch applied list');
        this.loadingApplied = false;
        this.$notify({
          text: `Failed to fetch applied list`,
          type: "error"
        });
      }
      
    },
    async applyData(items) {
      const data = { 
        "action": "create",
        "type": this.mode,
        "pointId": this.point.pointId,
        "ids": items 
      };
      
      axios.post(
        `${process.env.VUE_APP_QRPAY_ADMIN_HOST}/api/core/points-usages`,
        data
      )
      .then(response => {
        this.$notify({
          text: `Point applied:  ${items.length} ${ items.length > 1 ? 'items' : 'item'}`,
          type: 'success'
        });
        this.appliedPagination.page = 1;
        // this.fetchAppliedList();
      })
      .catch(err => {
        console.error(`Failed to apply tag`, err);
        this.$notify({
          text: `Point applied failed: ${err.message}`,
          type: 'error'
        });
      });
    }, 
    applyOne(item) {
      console.log('apply-one', item);
      let items = [item.id];
      this.applyData(items);
    },
    // unapplyOne(item) {
    //   console.log('unapply-one', item);
    //   let merchants = [item.id];
    //   this.unapplyData(merchants)
    // },
    applySelected() {
      const items = this.selectedApplied.map(item => item.id);
      this.applyData(items);
      this.selectedApplied = [];
    },
    onAppliedSearchUpdate(event) {
      this.appliedSearchBy = event.searchBy;
      this.appliedSearch = event.keyword;
    },
    async fetchData({ mode, page = 1, limit = 10, applied = true }) {
      const querystring = this.appliedSearchString;
      const startIndex = (page - 1 ) * limit;
      let url = '';
      let key = ''
      switch (mode) {
        case 'tags': 
          url = `${process.env.VUE_APP_QRPAY_ADMIN_HOST}/api/tags` +
            `?useTag=${applied}&limit=${limit}&startIndex=${startIndex}` + 
            (querystring ? `&${querystring}`: "") ;
          key = 'data';
        break;
        case 'merchants': 
          url = `${process.env.VUE_APP_QRPAY_ADMIN_HOST}/api/merchants?timeFormat=${encodeURIComponent('YYYY/M/D h:mm:ssA')}&include-beneficiaries=false`
            + `&limit=${limit}&startIndex=${startIndex}`
            + (querystring ? `&${querystring}`: "");
          key = 'merchants';
          break;
        default:
          url = `${process.env.VUE_APP_QRPAY_ADMIN_HOST}/api/tags` +
            `?useTag=${applied}&limit=${limit}&startIndex=${startIndex}` + 
            (querystring ? `&${querystring}`: "") ;
          key = 'data';
          break;
      }
        
      const fetchRes = await axios.get(url);
      return {
        items: fetchRes.data[key], total: fetchRes.data.total 
      }
      
    },

    reset(){
      this.mode = this.defaultMode;
      this.appliedPagination.page = 1;
      this.appliedSearch = '';
      this.appliedSearchBy = this.defaultSearchBy;
    },

    mockFetchData({ mode, search = "", page = 1, limit = 10, applied = true }) {
      
      const type = mode === "merchant" ? "merchantId" : "groupId";
      const totalItems = Array.from({ length: 50 }).map((_, i) => ({
        name: `${applied ? "已套用" : "未套用"} ${
          mode === "merchant" ? "店家" : "群組"
        } ${i + 1}`,
        [type]: `${mode}-${i + 1}`
      }));

      const filtered = totalItems.filter(item => item.name.includes(search));
      const paged = filtered.slice((page - 1) * limit, page * limit);

      return new Promise(resolve => {
        setTimeout(() => {
          resolve({ items: paged, total: filtered.length });
        }, 300);
      });
    },
    
  },
  mounted() {
    this.fetchAppliedList();
  },
  watch: {
    point: {
      immediate: true,
      handler(val) {
        this.fetchAppliedList();
      }
    },
  }
};
</script>
